import { render, staticRenderFns } from "./mrc_ess_chip.vue?vue&type=template&id=4b2c6ef5&scoped=true&"
import script from "./mrc_ess_chip.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_chip.vue?vue&type=script&lang=js&"
import style0 from "./mrc_ess_chip.vue?vue&type=style&index=0&id=4b2c6ef5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2c6ef5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
